"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_REBASES = exports.GET_POLICY_DATA = void 0;
const REBASE_FRAGMENT = `
  {
    id
    policy {
      id
    }
    epoch
    timestamp
    supply
    previousSupply
    precentageChange
    supplyAdjustment
    targetRate
    marketRate
  }
`;
exports.GET_POLICY_DATA = `
  query GetPolicyData ($id: ID!) {
    policies(where: { id: $id }) {
      id
      rebaseFunctionLowerPercentage
      rebaseFunctionUpperPercentage
      rebaseFunctionGrowth
      rebaseLag
      deviationThreshold
      minRebaseTimeIntervalSec
      rebaseWindowOffsetSec
      rebaseWindowLengthSec
      lastRebase ${REBASE_FRAGMENT}
    }
  }
`;
exports.GET_REBASES = `
  query GetRebases ($id: ID!, $first: Int!, $skip: Int) {
    rebases(where: { policy: $id },
      first: $first,
      skip: $skip,
      orderBy: timestamp,
      orderDirection: desc) ${REBASE_FRAGMENT}
  }
`;
//# sourceMappingURL=policy.js.map